// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============== Header CSS =============== */
.header_top_gradient {
    text-align: center;
    background-image: radial-gradient(
        circle,
        rgba(238, 174, 202, 1) 0%,
        rgba(148, 187, 233, 1) 100%
    );
    color: #ece5f6;
}
/* =========================================== */

/* =============== Data CSS =============== */
.card-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 23%));
    gap: 25px;
}

.card {
    background-color: #faf5f9;
    border: 1px solid #ccc;
    border-radius: 16px;
    padding: 10px;
    position: relative;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16), 0px 3px 6px rgba(0, 0, 0, 0.23);
    background: radial-gradient(
        circle,
        rgba(254, 252, 253, 1) 19%,
        rgba(233, 248, 251, 1) 51%,
        rgba(254, 254, 254, 1) 79%
    );
    transition: transform 0.2s;
}
.card:hover {
    background: -webkit-linear-gradient(#eee, #edfffe9f);
    transform: scale(1.015);
    cursor: pointer;
}

.card-header {
    padding: 5px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-title {
    display: inline-block;
    font-weight: bold;
    margin-right: 10px;
}

.card-title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-footer {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
}

.green-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: green;
}

.card-content {
    margin-top: 10px;
}

.divider {
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
}

.download-icon {
    width: 25px;
    height: 25px;
    background-image: url("https://img.icons8.com/?size=64&id=14100&format=png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}

.search-bar {
    width: 100%;
    height: 25px;
    box-sizing: border-box;
    border-radius: 16px;
    padding: 15px;
}
.search-container {
    margin-bottom: 10px;
}

.filter-dropdown {
    width: 100%;
    height: 35px;
    box-sizing: border-box;
    border-radius: 16px;
    padding: 0 0 0 10px;
}
/* =========================================== */

/* =============== Navbar CSS =============== */
.nav-custom {
    background-color: #94bbe9;
    color: #0e1117;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    padding: 10px 10px 0px 10px;
}

.nav-custom ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
}

.nav-custom a {
    color: inherit;
    text-decoration: none;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px 20px 10px 20px;
    font-size: 18px;
}

.nav-custom a.active {
    border-bottom: 0.2rem solid #0054a3;
}

.nav-custom a:hover {
    color: rgb(240, 240, 240);
}

.nav-custom li {
    padding: 0px 15px 0px 15px;
    border-bottom-width: 0.2rem;
    border-bottom-style: solid;
    border-bottom-color: transparent;
    box-sizing: border-box;
}

/* =========================================== */

/* =============== Leaderboard Page CSS =============== */
.search-leaderboard {
    margin-bottom: 10px;
    width: 100%;
    height: 25px;
    box-sizing: border-box;
    border-radius: 16px;
    padding: 15px;
}

table.leaderboard {
    border-collapse: collapse;
    width: 100%;
    border-radius: 10px;
}

table.leaderboard th {
    background-color: #f2f2f2;
    position: sticky;
    top: 0;
    z-index: 1;
}

table.leaderboard th,
table.leaderboard td {
    padding: 10px;
    text-align: left;
}

table.leaderboard tbody tr:nth-child(even) {
    background-color: #f9f9f9;
}

table.leaderboard tbody tr:hover {
    background-color: #e6f2ff;
}

table.leaderboard tbody {
    overflow-y: scroll;
    max-height: 100px;
}
/* =========================================== */

/* ============ Border Gradient ============ */
.border-gradient {
    border: 10px solid;
    border-image-slice: 1;
    border-width: 3px;
}

.border-gradient-green {
    border-image-source: linear-gradient(
        to right,
        #bd4043,
        #ed6f13,
        #158237,
        #0054a3,
        #6d3fc0
    );
}

.border-only-bottom {
    border-left: 0;
    border-right: 0;
    border-top: 0;
}
/* =========================================== */

/* ============ Pagination CSS ============ */

.pagination {
    margin-top: 10px;
    text-align: center;
}

.pagination p {
    display: inline-block;
    padding: 5px 10px;
    background-color: #dddddd;
    color: #333;
    text-decoration: none;
    margin-right: 5px;
    cursor: default;
}

.pagination p.active {
    background-color: #757575;
    color: #fff;
}

.pagination p:hover {
    cursor: pointer;
}

/* =========================================== */

/* ============ Table Customizerd CSS ============ */
.customized_table {
    /* font-family: Arial, Helvetica, sans-serif; */
    border-collapse: collapse;
    width: 100%;
}

.customized_table td,
.customized_table th {
    border: 1px solid #ddd;
    padding: 8px;
}

.customized_table tr:nth-child(even) {
    background-color: #f2f2f2;
}

.customized_table tr:hover {
    background-color: #ddd;
}

.customized_table th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #94bbe9;
    color: white;
}

/* =========================================== */

/* ============ Step Progress CSS ============ */
.step-boby {
    text-align: center;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
}

.step-circle {
    width: 36px;
    height: 36px;
    line-height: 30px;
    background-color: #0054a3;
    color: white;
    border-radius: 50%;
    border: 2px solid transparent;
    cursor: pointer;
    background-clip: padding-box;
}

.stepWrapper {
    display: flex;
    margin-bottom: 20px;
}

.stepBlock .circleWrapper {
    padding: 0px 100px;
    position: relative;
}

@media only screen and (max-width: 1200px) {
    .stepBlock .circleWrapper {
        padding: 0px 70px;
        position: relative;
    }
}

@media only screen and (max-width: 990px) {
    .stepBlock .circleWrapper {
        padding: 0px 120px;
        position: relative;
    }
}

@media only screen and (max-width: 650px) {
    .stepBlock .circleWrapper {
        padding: 0px 60px;
        position: relative;
    }
}

@media only screen and (max-width: 410px) {
    .stepBlock .circleWrapper {
        padding: 0px 30px;
        position: relative;
    }
}

.step-selected .step-circle {
    color: black;
    font-weight: bold;
    background-color: white;
    border-color: #0054a3;
}

.stepBlock:not(:last-child) > .circleWrapper::after {
    content: "";
    width: 100%;
    height: 2px;
    position: absolute;
    top: 0px;
    bottom: 0px;
    background-color: #0054a3;
    margin: auto;
    z-index: -1;
}

.stepBlock:not(:last-child) > .circleWrapper::after {
    height: 3px;
}

.stepBlock:not(:last-child).selected > .circleWrapper::after,
.stepBlock:not(:last-child).selected
    ~ .stepBlock:not(:last-child)
    > .circleWrapper::after {
    height: 2px;
    opacity: 0.6;
}
/* =========================================== */


.black-90-color {
    color: #161616;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;IACI,kBAAkB;IAClB;;;;KAIC;IACD,cAAc;AAClB;AACA,gDAAgD;;AAEhD,6CAA6C;AAC7C;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,4EAA4E;IAC5E;;;;;KAKC;IACD,0BAA0B;AAC9B;AACA;IACI,oDAAoD;IACpD,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4EAA4E;IAC5E,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;AACA,gDAAgD;;AAEhD,+CAA+C;AAC/C;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,gDAAgD;;AAEhD,yDAAyD;AACzD;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;;IAEI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA,gDAAgD;;AAEhD,8CAA8C;AAC9C;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI;;;;;;;KAOC;AACL;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;AACjB;AACA,gDAAgD;;AAEhD,6CAA6C;;AAE7C;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA,gDAAgD;;AAEhD,oDAAoD;AACpD;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;;AAEA,gDAAgD;;AAEhD,gDAAgD;AAChD;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;;;IAII,WAAW;IACX,YAAY;AAChB;AACA,gDAAgD;;;AAGhD;IACI,cAAc;AAClB","sourcesContent":["/* =============== Header CSS =============== */\n.header_top_gradient {\n    text-align: center;\n    background-image: radial-gradient(\n        circle,\n        rgba(238, 174, 202, 1) 0%,\n        rgba(148, 187, 233, 1) 100%\n    );\n    color: #ece5f6;\n}\n/* =========================================== */\n\n/* =============== Data CSS =============== */\n.card-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 23%));\n    gap: 25px;\n}\n\n.card {\n    background-color: #faf5f9;\n    border: 1px solid #ccc;\n    border-radius: 16px;\n    padding: 10px;\n    position: relative;\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16), 0px 3px 6px rgba(0, 0, 0, 0.23);\n    background: radial-gradient(\n        circle,\n        rgba(254, 252, 253, 1) 19%,\n        rgba(233, 248, 251, 1) 51%,\n        rgba(254, 254, 254, 1) 79%\n    );\n    transition: transform 0.2s;\n}\n.card:hover {\n    background: -webkit-linear-gradient(#eee, #edfffe9f);\n    transform: scale(1.015);\n    cursor: pointer;\n}\n\n.card-header {\n    padding: 5px;\n    font-size: 18px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.card-title {\n    display: inline-block;\n    font-weight: bold;\n    margin-right: 10px;\n}\n\n.card-title-wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.card-footer {\n    margin-top: 12px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.green-dot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: green;\n}\n\n.card-content {\n    margin-top: 10px;\n}\n\n.divider {\n    border-bottom: 1px solid #ccc;\n    margin-bottom: 10px;\n}\n\n.download-icon {\n    width: 25px;\n    height: 25px;\n    background-image: url(\"https://img.icons8.com/?size=64&id=14100&format=png\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    cursor: pointer;\n}\n\n.search-bar {\n    width: 100%;\n    height: 25px;\n    box-sizing: border-box;\n    border-radius: 16px;\n    padding: 15px;\n}\n.search-container {\n    margin-bottom: 10px;\n}\n\n.filter-dropdown {\n    width: 100%;\n    height: 35px;\n    box-sizing: border-box;\n    border-radius: 16px;\n    padding: 0 0 0 10px;\n}\n/* =========================================== */\n\n/* =============== Navbar CSS =============== */\n.nav-custom {\n    background-color: #94bbe9;\n    color: #0e1117;\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    padding: 10px 10px 0px 10px;\n}\n\n.nav-custom ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n}\n\n.nav-custom a {\n    color: inherit;\n    text-decoration: none;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 10px 20px 10px 20px;\n    font-size: 18px;\n}\n\n.nav-custom a.active {\n    border-bottom: 0.2rem solid #0054a3;\n}\n\n.nav-custom a:hover {\n    color: rgb(240, 240, 240);\n}\n\n.nav-custom li {\n    padding: 0px 15px 0px 15px;\n    border-bottom-width: 0.2rem;\n    border-bottom-style: solid;\n    border-bottom-color: transparent;\n    box-sizing: border-box;\n}\n\n/* =========================================== */\n\n/* =============== Leaderboard Page CSS =============== */\n.search-leaderboard {\n    margin-bottom: 10px;\n    width: 100%;\n    height: 25px;\n    box-sizing: border-box;\n    border-radius: 16px;\n    padding: 15px;\n}\n\ntable.leaderboard {\n    border-collapse: collapse;\n    width: 100%;\n    border-radius: 10px;\n}\n\ntable.leaderboard th {\n    background-color: #f2f2f2;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\ntable.leaderboard th,\ntable.leaderboard td {\n    padding: 10px;\n    text-align: left;\n}\n\ntable.leaderboard tbody tr:nth-child(even) {\n    background-color: #f9f9f9;\n}\n\ntable.leaderboard tbody tr:hover {\n    background-color: #e6f2ff;\n}\n\ntable.leaderboard tbody {\n    overflow-y: scroll;\n    max-height: 100px;\n}\n/* =========================================== */\n\n/* ============ Border Gradient ============ */\n.border-gradient {\n    border: 10px solid;\n    border-image-slice: 1;\n    border-width: 3px;\n}\n\n.border-gradient-green {\n    border-image-source: linear-gradient(\n        to right,\n        #bd4043,\n        #ed6f13,\n        #158237,\n        #0054a3,\n        #6d3fc0\n    );\n}\n\n.border-only-bottom {\n    border-left: 0;\n    border-right: 0;\n    border-top: 0;\n}\n/* =========================================== */\n\n/* ============ Pagination CSS ============ */\n\n.pagination {\n    margin-top: 10px;\n    text-align: center;\n}\n\n.pagination p {\n    display: inline-block;\n    padding: 5px 10px;\n    background-color: #dddddd;\n    color: #333;\n    text-decoration: none;\n    margin-right: 5px;\n    cursor: default;\n}\n\n.pagination p.active {\n    background-color: #757575;\n    color: #fff;\n}\n\n.pagination p:hover {\n    cursor: pointer;\n}\n\n/* =========================================== */\n\n/* ============ Table Customizerd CSS ============ */\n.customized_table {\n    /* font-family: Arial, Helvetica, sans-serif; */\n    border-collapse: collapse;\n    width: 100%;\n}\n\n.customized_table td,\n.customized_table th {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\n.customized_table tr:nth-child(even) {\n    background-color: #f2f2f2;\n}\n\n.customized_table tr:hover {\n    background-color: #ddd;\n}\n\n.customized_table th {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    text-align: left;\n    background-color: #94bbe9;\n    color: white;\n}\n\n/* =========================================== */\n\n/* ============ Step Progress CSS ============ */\n.step-boby {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    box-sizing: border-box;\n}\n\n.step-circle {\n    width: 36px;\n    height: 36px;\n    line-height: 30px;\n    background-color: #0054a3;\n    color: white;\n    border-radius: 50%;\n    border: 2px solid transparent;\n    cursor: pointer;\n    background-clip: padding-box;\n}\n\n.stepWrapper {\n    display: flex;\n    margin-bottom: 20px;\n}\n\n.stepBlock .circleWrapper {\n    padding: 0px 100px;\n    position: relative;\n}\n\n@media only screen and (max-width: 1200px) {\n    .stepBlock .circleWrapper {\n        padding: 0px 70px;\n        position: relative;\n    }\n}\n\n@media only screen and (max-width: 990px) {\n    .stepBlock .circleWrapper {\n        padding: 0px 120px;\n        position: relative;\n    }\n}\n\n@media only screen and (max-width: 650px) {\n    .stepBlock .circleWrapper {\n        padding: 0px 60px;\n        position: relative;\n    }\n}\n\n@media only screen and (max-width: 410px) {\n    .stepBlock .circleWrapper {\n        padding: 0px 30px;\n        position: relative;\n    }\n}\n\n.step-selected .step-circle {\n    color: black;\n    font-weight: bold;\n    background-color: white;\n    border-color: #0054a3;\n}\n\n.stepBlock:not(:last-child) > .circleWrapper::after {\n    content: \"\";\n    width: 100%;\n    height: 2px;\n    position: absolute;\n    top: 0px;\n    bottom: 0px;\n    background-color: #0054a3;\n    margin: auto;\n    z-index: -1;\n}\n\n.stepBlock:not(:last-child) > .circleWrapper::after {\n    height: 3px;\n}\n\n.stepBlock:not(:last-child).selected > .circleWrapper::after,\n.stepBlock:not(:last-child).selected\n    ~ .stepBlock:not(:last-child)\n    > .circleWrapper::after {\n    height: 2px;\n    opacity: 0.6;\n}\n/* =========================================== */\n\n\n.black-90-color {\n    color: #161616;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
